import React from "react";
import bgImage from "@/assets/lerch-plus/bild-lerch-plus.webp";
import lPlusMark from "@/assets/icons/Bildmarke_plus.svg";
import { EditableT, EditableTLink, EditableImage } from "@/cms/EditableT";

const LerchPlusSection: React.FC<{ className?: string }> = ({ className }) => {

  return (
    <section
      aria-labelledby="lerch-plus-heading"
      className={`w-full bg-white ${className ?? ""}`}
    >
      <div className="relative mx-auto w-full max-w-[1859px] overflow-hidden bg-[#383637]">
        <EditableImage
          id="home.lerch_plus.bg_image"
          src={bgImage}
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="relative grid gap-10 lg:gap-[60px] xl:gap-[100px] 2xl:gap-[150px] lg:grid-cols-[minmax(0,1fr)_minmax(0,1.7fr)] lg:justify-center items-center px-6 sm:px-10 lg:px-12 xl:px-16 py-24 md:py-32 lg:py-[180px]">
          <div className="hidden lg:flex justify-end">
            <img
              src={lPlusMark}
              alt=""
              aria-hidden="true"
              className="pointer-events-none select-none w-full max-w-[300px] xl:max-w-[380px] 2xl:max-w-[442px] h-auto" width={1600} height={1067} loading="lazy" decoding="async"
            />
          </div>
          <article className="flex w-full flex-col items-start gap-[55px] text-[#F2F2F2]">
            <header className="flex flex-col gap-[35px] w-full">
              <span className="block font-['Kumbh_Sans'] text-[15px] md:text-[19px] font-normal uppercase leading-[25px] tracking-[0.25em] max-w-[561px]">
                <EditableT k="home.lerch_plus.kicker" />
              </span>
              <h2
                id="lerch-plus-heading"
                className="font-['Kumbh_Sans'] text-[28px] md:text-[36px] lg:text-[45px] font-extralight uppercase leading-[1.1] tracking-[0.05em] max-w-[420px] [text-wrap:balance]"
              >
                <EditableT k="home.lerch_plus.headline" multiline />
              </h2>
            </header>
            <div className="font-['Baskervville'] text-[17px] font-normal leading-[28px] tracking-[0.02em] space-y-6 whitespace-pre-line max-w-[648px]">
              <EditableT k="home.lerch_plus.body" multiline />
            </div>
            <EditableTLink
              k="home.lerch_plus.cta_label"
              href="/lerch-plus"
              className="inline-flex items-center justify-center h-[37px] px-[30px] rounded-full bg-[#6C184F] leading-none hover:bg-[#581340] transition-colors text-[#F2F2F2] font-['Kumbh_Sans'] text-[14px] font-medium uppercase tracking-[0.08em]"
            />
          </article>
        </div>
      </div>
    </section>
  );
};

export default LerchPlusSection;
